(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6660],{

/***/ 6830:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var scm = (__webpack_require__(91538).scm);
var pagePermissionKey = {
    // #region root menu
    generalSettings: {
        permissionKey: "ac-console-6"
    },
    marketing: {
        permissionKey: "ac-rolemanagement-3"
    },
    finances: {
        permissionKey: "ac-console"
    },
    analytics: {
        permissionKey: "ac-console-2"
    },
    courseware: {
        permissionKey: "ac-studio-2"
    },
    certificateTemplate: {
        permissionKey: "ac-rolemanagement-1"
    },
    // group menu
    organization: {
        permissionKey: "ac-console"
    },
    customization: {
        permissionKey: "ac-console"
    },
    userAccountSetting: {
        permissionKey: "ac-console"
    },
    // #endregion
    // #region Sub Pages
    banner: {
        permissionKey: "ac-console-7"
    },
    categories: {
        permissionKey: "ac-console-6"
    },
    campaign: {
        permissionKey: "ac-console-10"
    },
    coupons: {
        permissionKey: "ac-console-11"
    },
    contentCompletion: {
        permissionKey: "ac-console-8"
    },
    courseWhitelist: {
        permissionKey: "ac-console-102"
    },
    courseOverviewReport: {
        permissionKey: "ac-console-13"
    },
    groupManagement: {
        permissionKey: "ac-console-15"
    },
    learnerProgressReport: {
        permissionKey: "ac-console-2"
    },
    memberPermission: {
        permissionKey: "ac-console-14"
    },
    memberManagement: {
        permissionKey: "ac-console-14"
    },
    memberInformation: {
        permissionKey: "ac-console-14"
    },
    myCourse: {
        permissionKey: "ac-studio-2"
    },
    myLibrary: {
        permissionKey: "ac-studio-2"
    },
    orderManagement: {
        permissionKey: "ac-console-12"
    },
    overviewDashboard: {
        permissionKey: "ac-console-2"
    },
    paymentSetting: {
        permissionKey: "ac-console-9"
    },
    priceVisibility: {
        permissionKey: "ac-console-16"
    },
    discussionSetting: {
        permissionKey: "ac-console-17"
    },
    personalInformation: {
        permissionKey: "ac-console-18"
    }
};
// DKAHR should hide ["coupons", "orderManagement", "campaign"]
if (scm.explore.use_tms_adapter) {
    var filterKey = [
        "coupons",
        "orderManagement",
        "campaign"
    ];
    filterKey.forEach(function(key) {
        if (pagePermissionKey[key]) {
            pagePermissionKey[key].disabled = true;
        } else {
            throw Error("".concat(key, " is not found"));
        }
    });
}
module.exports = pagePermissionKey;


/***/ }),

/***/ 41400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ handleFnsIntl; },
/* harmony export */   "bh": function() { return /* binding */ flattenMessages; }
/* harmony export */ });
/* unused harmony export IntlMappings */
/* harmony import */ var date_fns_locale_en_US__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95826);
/* harmony import */ var date_fns_locale_zh_CN__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3644);
/* harmony import */ var date_fns_locale_zh_TW__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85673);



var flattenMessages = function(nestedMessages) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return Object.keys(nestedMessages).reduce(function(messages, key) {
        var acc = messages;
        var value = nestedMessages[key];
        var prefixedKey = prefix ? "".concat(prefix, ".").concat(key) : key;
        if (typeof value === "string") {
            acc[prefixedKey] = value;
        } else {
            Object.assign(acc, flattenMessages(value, prefixedKey));
        }
        return acc;
    }, {});
};
var IntlMappings = function(displayUnauthorized) {
    var language;
    if (localStorage.getItem("lang")) {
        language = localStorage.getItem("lang");
    } else if (!displayUnauthorized) {
        language = "zh-Hant";
    } else if (navigator.language === "zh-TW") {
        language = "zh-Hant";
    } else if (navigator.language === "zh-CN") {
        language = "zh-Hans";
    } else {
        language = "en";
    }
    return language;
};
var handleFnsIntl = function(language) {
    var locales = {
        enUS: date_fns_locale_en_US__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
        zhCN: date_fns_locale_zh_CN__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
        zhTW: date_fns_locale_zh_TW__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    };
    var res;
    switch(language){
        case "zh-Hant":
            res = "zhTW";
            break;
        case "zh-Hans":
            res = "zhCN";
            break;
        default:
            res = "enUS";
            break;
    }
    return locales[res];
};


/***/ }),

/***/ 24990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/AppEnv/index.js + 2 modules
var AppEnv = __webpack_require__(70146);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(95570);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/page-components/Footer/Footer.module.scss
var Footer_module = __webpack_require__(3894);
;// CONCATENATED MODULE: ./src/page-components/Footer/Footer.js









var QRCode = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4059).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var _scm_footer;
var _ref = (_scm_footer = AppEnv/* scm.footer */.zE.footer) !== null && _scm_footer !== void 0 ? _scm_footer : {}, custom = _ref.custom, icp = _ref.icp, customizedCopyright = _ref.customized_copyright;
var SHOW_DOWNLOAD_SCREEN = AppEnv/* scm.download.show_app_download_screen */.zE.download.show_app_download_screen;
var Footer = function() {
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var handleClick = function(event, param) {
        event.preventDefault();
        router.push("/".concat(param));
    };
    var handleUserGuideURL = function() {
        switch(intl.locale){
            case "zh-Hans":
                return AppEnv/* USER_GUIDE_URL_ZH_HANS */.yl;
            case "zh-Hant":
                return AppEnv/* USER_GUIDE_URL_ZH_HANT */.sq;
            case "en":
            default:
                return AppEnv/* USER_GUIDE_URL_EN */.ku;
        }
    };
    var showIcp = !!icp && icp.length >= 2;
    var showCustomizedCopyright = !!customizedCopyright;
    var iOSDownloadLink = AppEnv/* IOS_DOWNLOAD_LINK */.X || "";
    var androidDownloadLink = AppEnv/* ANDROID_DOWNLOAD_LINK */.b4 || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: Footer_module.footer,
            id: "footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: Footer_module.content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: Footer_module.copy_right,
                        children: [
                            "\xa9",
                            " ".concat((0,getYear/* default */.Z)(new Date()), " "),
                            showCustomizedCopyright ? customizedCopyright : "Delta Electronics, Inc. All Rights Reserved.",
                            showIcp ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: Footer_module.security_wrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: Footer_module.security_content_wrapper,
                                        children: icp[0]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: Footer_module.security_content_icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/images/security.png",
                                            width: 20,
                                            height: 20,
                                            alt: "icp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: Footer_module.security_content_wrapper,
                                        children: icp[1]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: Footer_module.links,
                                children: [
                                    SHOW_DOWNLOAD_SCREEN ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: Footer_module.nav_link,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/download",
                                                onClick: function(event) {
                                                    return handleClick(event, "download");
                                                },
                                                children: intl.formatMessage({
                                                    id: "common.pageName.downloadApp",
                                                    defaultMessage: "Download our App"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: Footer_module.divider,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: Footer_module.nav_link,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: handleUserGuideURL(),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: intl.formatMessage({
                                                    id: "common.pageName.userGuide",
                                                    defaultMessage: "User Guide"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: Footer_module.divider,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: Footer_module.nav_link,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/terms",
                                                onClick: function(event) {
                                                    return handleClick(event, "terms");
                                                },
                                                children: intl.formatMessage({
                                                    id: "common.pageName.termsOfUse",
                                                    defaultMessage: "Terms Of Use"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: Footer_module.divider,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: Footer_module.nav_link,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/privacy",
                                                onClick: function(event) {
                                                    return handleClick(event, "privacy");
                                                },
                                                children: intl.formatMessage({
                                                    id: "common.pageName.privacyPolicy",
                                                    defaultMessage: "Privacy Policy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: Footer_module.divider,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: Footer_module.nav_link,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/dataPolicy",
                                                onClick: function(event) {
                                                    return handleClick(event, "dataPolicy");
                                                },
                                                children: intl.formatMessage({
                                                    id: "common.pageName.dataCollection",
                                                    defaultMessage: "Data Collection"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: Footer_module.divider,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: Footer_module.nav_link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: AppEnv/* appJson.version */.Sq.version[AppEnv/* REACT_APP_ENV */._s]
                                        })
                                    })
                                ]
                            }),
                            custom === "qrcode" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: Footer_module.qrcode,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: Footer_module.code,
                                    children: [
                                        intl.formatMessage({
                                            id: "footer.text.academyMobileAppForIosAndAndroid",
                                            defaultMessage: "Academy mobile app for iOS and Android"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: Footer_module.suggestion,
                                            children: intl.formatMessage({
                                                id: "footer.text.iosSuggestion",
                                                defaultMessage: "For iOS users, please use the built-in Camera App to scan the QR code"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: Footer_module.code_img,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: iOSDownloadLink,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode, {
                                                                value: iOSDownloadLink,
                                                                size: 76,
                                                                bgColor: "#ffffff",
                                                                fgColor: "#272727",
                                                                level: "L",
                                                                includeMargin: false,
                                                                renderAs: "svg"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: AppEnv/* IOS_INSTALL_GUIDE */.EC,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    textDecoration: "underline"
                                                                },
                                                                children: intl.formatMessage({
                                                                    id: "footer.text.iosQuickGuide",
                                                                    defaultMessage: "iOS Quick Start Guide"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: androidDownloadLink,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode, {
                                                                value: androidDownloadLink,
                                                                size: 76,
                                                                bgColor: "#ffffff",
                                                                fgColor: "#272727",
                                                                level: "L",
                                                                includeMargin: false,
                                                                renderAs: "svg"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: AppEnv/* ANDROID_INSTALL_GUIDE */.zP,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    textDecoration: "underline"
                                                                },
                                                                children: intl.formatMessage({
                                                                    id: "footer.text.androidQuickGuide",
                                                                    defaultMessage: "Android Quick Start Guide"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/page-components/Footer/index.js

/* harmony default export */ var page_components_Footer = (Footer_Footer);


/***/ }),

/***/ 58905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19077);

/* harmony default export */ __webpack_exports__["Z"] = (_Header__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 68411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_components_ViewAllTooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/withStyles/withStyles.js
var withStyles = __webpack_require__(38920);
// EXTERNAL MODULE: ./src/utils/text-utils.js
var text_utils = __webpack_require__(23906);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/page-components/ViewAllTooltip/ViewAllTooltip.js






var ViewAllTooltip = function(param) {
    var _param_children = param.children, children = _param_children === void 0 ? null : _param_children, _param_width = param.width, width = _param_width === void 0 ? "" : _param_width;
    var _childRef_current;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), showTooltip = _useState[0], setShowTooltip = _useState[1];
    var ref = (0,react.useRef)(null);
    var ChildrenCloneElement = /*#__PURE__*/ (0,react.cloneElement)(children, {
        ref: ref
    });
    var childRef = ChildrenCloneElement.ref;
    var content = (childRef === null || childRef === void 0 ? void 0 : (_childRef_current = childRef.current) === null || _childRef_current === void 0 ? void 0 : _childRef_current.innerText) || "";
    var StyledTooltip = (0,react.useMemo)(function(maxWidth) {
        return (0,withStyles/* default */.Z)({
            tooltip: {
                maxWidth: maxWidth || "960px",
                lineHeight: "14px",
                fontSize: "12px",
                fontWeight: "400",
                padding: "4px 8px"
            },
            tooltipPlacementBottom: {
                marginTop: "-4px"
            }
        })(Tooltip/* default */.ZP);
    }, [
        width
    ]);
    var handleResize = function() {
        setShowTooltip((0,text_utils/* isTextTruncated */.Op)(childRef));
    };
    (0,react.useEffect)(function() {
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, [
        childRef,
        content
    ]);
    return showTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooltip, {
        placement: "bottom",
        title: content,
        children: ChildrenCloneElement
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: ChildrenCloneElement
    });
};
/* harmony default export */ var ViewAllTooltip_ViewAllTooltip = (ViewAllTooltip);

;// CONCATENATED MODULE: ./src/page-components/ViewAllTooltip/index.js

/* harmony default export */ var page_components_ViewAllTooltip = (ViewAllTooltip_ViewAllTooltip);


/***/ }),

/***/ 81266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h5": function() { return /* binding */ getCourseContentUrl; }
/* harmony export */ });
/* unused harmony exports checkIsProvider, checkIsInstructor, getLoginStatus, redirectToDestination, generatePageProps, pageAccess, checkPagePermit, getStudioCustomRedirection, redirectToStudioLandingInGetServerSideProps, redirectToExplore, consoleDirectPage */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var _configs_nodeEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91538);
/* harmony import */ var _configs_nodeEnv__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_configs_nodeEnv__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _configs_page_permissionKey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6830);
/* harmony import */ var _configs_page_permissionKey__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_configs_page_permissionKey__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_auth_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1894);
/* harmony import */ var _utils_route_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11693);
/* harmony import */ var _utils_server_api_point__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44957);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var querystringify__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57129);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9280);












var checkIsProvider = function(userPrivilege) {
    var providerToken = function(item) {
        return item === "ac-studio-1";
    };
    return userPrivilege ? findIndex(providerToken, userPrivilege) !== -1 : false;
};
var checkIsInstructor = function(userPrivilege) {
    var instructorToken = function(item) {
        return item === "ac-console-5";
    };
    return userPrivilege ? findIndex(instructorToken, userPrivilege) !== -1 : false;
};
var getLoginStatus = function(ctx) {
    var _ref = (0,cookies_next__WEBPACK_IMPORTED_MODULE_5__.getCookies)(ctx) || {}, avatar = _ref.avatar, token = _ref.token, email = _ref.email, loginType = _ref.loginType, name = _ref.name;
    return {
        token: token || "",
        email: email || "",
        avatar: avatar ? decodeURIComponent(avatar) : "",
        name: name ? decodeURIComponent(name) : "",
        loginType: loginType || ""
    };
};
var redirectToDestination = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_destination = _ref.destination, destination = _ref_destination === void 0 ? appRootPath : _ref_destination, reason = _ref.reason;
    var reasonHashTag = reason ? "#".concat(reason) : "";
    var destinationValue = "".concat(destination).concat(reasonHashTag);
    return {
        redirect: {
            permanent: false,
            destination: destinationValue
        }
    };
};
var generatePageProps = function(param) {
    var pageData = param.pageData, _param_accessPageKey = param.accessPageKey, accessPageKey = _param_accessPageKey === void 0 ? "" : _param_accessPageKey, _param_customProps = param.customProps, customProps = _param_customProps === void 0 ? {} : _param_customProps, _param_customRedirection = param.customRedirection, customRedirection = _param_customRedirection === void 0 ? null : _param_customRedirection;
    var theme = pageData.theme, userPrivilege = pageData.userPrivilege, url = pageData.url, loginStatus = pageData.loginStatus;
    var _loginStatus_email = loginStatus.email, email = _loginStatus_email === void 0 ? "unknown" : _loginStatus_email, token = loginStatus.token;
    var tokenValid = isTokenAvailable(token);
    var isRootUrl = url.includes(appRootPath);
    if (!checkPageIsPublic(theme) && !tokenValid && !isRootUrl) {
        console.log("[CLIENT_PAGE_DENY],".concat(email, ",").concat(url, ",401"));
        return _object_spread_props(_object_spread({}, redirectToDestination({
            reason: "401"
        })), {
            props: {
                data: pageData
            }
        });
    }
    if (accessPageKey) {
        if (!checkPagePermit({
            privilege: userPrivilege,
            accessPageKey: accessPageKey
        })) {
            console.log("[CLIENT_PAGE_DENY],".concat(email, ",").concat(url, ",403"));
            return _object_spread_props(_object_spread({}, redirectToDestination({
                destination: tokenValid ? "/" : undefined,
                reason: "403"
            })), {
                props: {
                    data: pageData
                }
            });
        }
    }
    return _object_spread_props(_object_spread({}, customRedirection), {
        props: _object_spread_props(_object_spread({}, customProps), {
            data: pageData
        })
    });
};
var pageAccess = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(ctx, theme) {
        var loginStatus, _ref, privilegeData, _tmp, _ref1, userPrivacyData, _tmp1, userPrivacy, userPrivilege;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loginStatus = getLoginStatus(ctx);
                    if (!loginStatus.token) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,_utils_server_api_point__WEBPACK_IMPORTED_MODULE_4__/* .getUserPrivilege */ .jC)(loginStatus)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = {};
                    _state.label = 3;
                case 3:
                    _ref = _tmp, privilegeData = _ref.data;
                    if (!loginStatus.token) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0,_utils_server_api_point__WEBPACK_IMPORTED_MODULE_4__/* .getUserPrivacy */ .wL)(loginStatus)
                    ];
                case 4:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    _tmp1 = {};
                    _state.label = 6;
                case 6:
                    _ref1 = _tmp1, userPrivacyData = _ref1.data;
                    userPrivacy = userPrivacyData || {};
                    userPrivilege = privilegeData || [];
                    return [
                        2,
                        {
                            url: ctx.req.url,
                            loginStatus: loginStatus,
                            theme: theme,
                            userPrivilege: userPrivilege,
                            userPrivacy: {
                                activity: userPrivacy.activity === "true",
                                enrollment: userPrivacy.enrollment === "true",
                                information: userPrivacy.information === "true",
                                location: userPrivacy.location === "true"
                            }
                        }
                    ];
            }
        });
    });
    return function pageAccess(ctx, theme) {
        return _ref.apply(this, arguments);
    };
}();
var getCourseContentUrl = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var _param_courseId, courseId, _param_learnContentId, learnContentId, getUserUnfinishedField, getEnrollStatus, _param_getLearningSyllabus, getLearningSyllabus, _ref, getUserUnfinishedFieldData, getUserUnfinishedFieldError, _ref1, enrollStatus, enrollError, _ref2, data, error, dataContent, _ref3, _ref_chapters, chapters, _ref_preview, preview, _ref_previewVideo, previewVideo, previewItem, itemArray, isTarget, itemTarget, error1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param_courseId = param.courseId, courseId = _param_courseId === void 0 ? "" : _param_courseId, _param_learnContentId = param.learnContentId, learnContentId = _param_learnContentId === void 0 ? null : _param_learnContentId, getUserUnfinishedField = param.getUserUnfinishedField, getEnrollStatus = param.getEnrollStatus, _param_getLearningSyllabus = param.getLearningSyllabus, getLearningSyllabus = _param_getLearningSyllabus === void 0 ? /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    // This is intentional
                    }) : _param_getLearningSyllabus;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    if (!(typeof getUserUnfinishedField === "function")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getUserUnfinishedField()
                    ];
                case 2:
                    _ref = _state.sent(), getUserUnfinishedFieldData = _ref.data, getUserUnfinishedFieldError = _ref.error;
                    if (!getUserUnfinishedFieldError && (getUserUnfinishedFieldData === null || getUserUnfinishedFieldData === void 0 ? void 0 : getUserUnfinishedFieldData.length)) return [
                        2,
                        {
                            url: "/myJournal/complete?".concat(querystringify__WEBPACK_IMPORTED_MODULE_6__.stringify({
                                courseId: courseId,
                                learnContentId: learnContentId
                            }))
                        }
                    ];
                    _state.label = 3;
                case 3:
                    if (!(typeof getEnrollStatus === "function")) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        getEnrollStatus({
                            itemType: "course",
                            itemId: courseId
                        })
                    ];
                case 4:
                    _ref1 = _state.sent(), enrollStatus = _ref1.data, enrollError = _ref1.error;
                    if (!enrollError && !enrollStatus) {
                        return [
                            2,
                            {
                                url: "/course/preview/".concat(courseId),
                                error: "courseHasNotBeenEnrolled"
                            }
                        ];
                    }
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        getLearningSyllabus()
                    ];
                case 6:
                    _ref2 = _state.sent(), data = _ref2.data, error = _ref2.error;
                    if (error) {
                        return [
                            2,
                            {
                                url: "/explore",
                                error: "courseNotFound"
                            }
                        ];
                    }
                    dataContent = data.content || data.courseContent;
                    _ref3 = dataContent || {}, _ref_chapters = _ref3.chapters, chapters = _ref_chapters === void 0 ? [] : _ref_chapters, _ref_preview = _ref3.preview, preview = _ref_preview === void 0 ? {} : _ref_preview, _ref_previewVideo = _ref3.previewVideo, previewVideo = _ref_previewVideo === void 0 ? {} : _ref_previewVideo;
                    previewItem = preview[0] || previewVideo;
                    itemArray = [];
                    if (previewItem.id) {
                        itemArray.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, previewItem), {
                            type: "video"
                        }));
                    }
                    chapters.forEach(function(chapter) {
                        chapter.items.forEach(function(item) {
                            itemArray.push(item);
                        });
                    });
                    isTarget = function(item) {
                        return item.id === learnContentId;
                    };
                    itemTarget = itemArray.find(isTarget) || (dataContent === null || dataContent === void 0 ? void 0 : dataContent.chapters[0].items[0]);
                    if (itemTarget) {
                        return [
                            2,
                            {
                                url: "/course/".concat(courseId, "/").concat(itemTarget.type, "/").concat(itemTarget.id)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            url: "/course/preview/".concat(courseId),
                            error: "contentNotFound"
                        }
                    ];
                case 7:
                    error1 = _state.sent();
                    console.error("getCourseContentUrl", error1);
                    return [
                        2,
                        {
                            url: "/explore",
                            error: "courseNotFound"
                        }
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCourseContentUrl(_) {
        return _ref.apply(this, arguments);
    };
}();
var checkPagePermit = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_privilege = _ref.privilege, privilege = _ref_privilege === void 0 ? [] : _ref_privilege, _ref_accessPageKey = _ref.accessPageKey, accessPageKey = _ref_accessPageKey === void 0 ? "" : _ref_accessPageKey;
    if (privilege.length === 0 && !accessPageKey) {
        return true;
    }
    if (accessPageKey) {
        var _pagePermitKeyList_accessPageKey;
        // check accessPageKey
        var privilegeKey = privilege.map(function(item) {
            return item;
        });
        var authorizedKey = (_pagePermitKeyList_accessPageKey = pagePermitKeyList[accessPageKey]) === null || _pagePermitKeyList_accessPageKey === void 0 ? void 0 : _pagePermitKeyList_accessPageKey.permissionKey;
        if (authorizedKey) {
            return privilegeKey.includes(authorizedKey);
        }
        console.warn("[PAGE_PERMIT] due to ".concat(accessPageKey, " is not defined"));
        // enter an undefined page
        return true;
    }
    // enter an open page
    return true;
};
var getStudioCustomRedirection = function(param) {
    var pageData = param.pageData, _param_apiError = param.apiError, apiError = _param_apiError === void 0 ? false : _param_apiError;
    var userPrivilege = pageData.userPrivilege;
    var isProvider = checkIsProvider(userPrivilege);
    var isApiError = !!apiError;
    if (isApiError && isProvider) {
        return redirectToStudioLandingInGetServerSideProps;
    }
    if (!isProvider) {
        return redirectToExplore;
    }
    return null;
};
var redirectToStudioLandingInGetServerSideProps = {
    redirect: {
        permanent: false,
        destination: "/studio/courseware/myCourse"
    }
};
var redirectToExplore = {
    redirect: {
        permanent: false,
        destination: "/explore"
    }
};
var consoleDirectPage = function(param) {
    var useTmsAdapter = param.useTmsAdapter, userPrivilege = param.userPrivilege;
    if (useTmsAdapter) {
        return "/console/learner-progress-report";
    }
    if (userPrivilege.includes("ac-console-2")) {
        return "/console/overview-dashboard";
    }
    if (userPrivilege.includes("ac-console-13")) {
        return "/console/course-overview-report";
    }
    return "/";
};


/***/ }),

/***/ 19305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M6": function() { return /* binding */ postCreateBundleCourse; },
/* harmony export */   "ZV": function() { return /* binding */ deleteBundleCourse; },
/* harmony export */   "cc": function() { return /* binding */ getCampaignEnrollStatusPoint; },
/* harmony export */   "lu": function() { return /* binding */ getEnrollStatus; },
/* harmony export */   "nA": function() { return /* binding */ updateCampaignInfo; },
/* harmony export */   "oB": function() { return /* binding */ getConsoleBundleCourseList; },
/* harmony export */   "r_": function() { return /* binding */ getCampaignInfoPoint; },
/* harmony export */   "w7": function() { return /* binding */ searchCourseByTypePoint; }
/* harmony export */ });
/* harmony import */ var _components_AppEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70146);
/* harmony import */ var _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52157);
var _scm_explore;


var useTmsAdapter = _components_AppEnv__WEBPACK_IMPORTED_MODULE_0__/* .scm */ .zE === null || _components_AppEnv__WEBPACK_IMPORTED_MODULE_0__/* .scm */ .zE === void 0 ? void 0 : (_scm_explore = _components_AppEnv__WEBPACK_IMPORTED_MODULE_0__/* .scm.explore */ .zE.explore) === null || _scm_explore === void 0 ? void 0 : _scm_explore.use_tms_adapter;
var postCreateBundleCourse = function(param) {
    var title = param.title, description = param.description;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post("/api/v1/catalog/campaign/console", {
        title: title,
        description: description
    }).then(function(res) {
        return res.data;
    });
};
var deleteBundleCourse = function(param) {
    var id = param.id;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["delete"] */ .ZP["delete"]("/api/v1/catalog/campaign/console/".concat(id)).then(function(res) {
        return res.data;
    });
};
var getConsoleBundleCourseList = function(pageNum) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/catalog/campaign/console?pageSize=7&sortKey=create_time&sortOrder=-1&pageNum=".concat(pageNum)).then(function(res) {
        return res.data;
    });
};
var updateCampaignInfo = function(props) {
    var campaignId = props.campaignId, updateCampaignData = props.updateCampaignData;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].put */ .ZP.put("/api/v1/catalog/campaign/console/".concat(campaignId), updateCampaignData).then(function(response) {
        return response.data;
    });
};
var getCampaignInfoPoint = function(campaignId) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/catalog/campaign/console/".concat(campaignId)).then(function(res) {
        return res.data;
    });
};
var searchCourseByTypePoint = function(type, keyword) {
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/".concat(useTmsAdapter ? "tms-adapter/" : "", "search/catalog/").concat(type, "/course?keyword=").concat(keyword)).then(function(res) {
        return res.data;
    });
};
var getEnrollStatus = function(param) {
    var itemId = param.itemId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/learning-system/course/".concat(itemId, "/enroll_status")).then(function(res) {
        return res.data;
    });
};
var getCampaignEnrollStatusPoint = function(param) {
    var itemId = param.itemId;
    return _utils_axios_client_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/order-system/campaign/".concat(itemId, "/enroll_status")).then(function(res) {
        return res.data;
    });
};



/***/ }),

/***/ 99465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DF": function() { return /* binding */ courseDirectHelper; },
/* harmony export */   "Hd": function() { return /* binding */ directToCourseNotFound; },
/* harmony export */   "Ls": function() { return /* binding */ checkLearningItemExisted; },
/* harmony export */   "R0": function() { return /* binding */ translateToSkillLevel; },
/* harmony export */   "XM": function() { return /* binding */ directToHasNotBeenEnrolledError; },
/* harmony export */   "mq": function() { return /* binding */ directToNoLogin; },
/* harmony export */   "yY": function() { return /* binding */ directToContentNotFound; }
/* harmony export */ });
/* unused harmony exports directToSyllabusError, pageDirectJudgment */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var _router_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81266);
/* harmony import */ var _utils_apiServices_campaign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19305);
/* harmony import */ var _utils_apiServices_explore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8031);
/* harmony import */ var _utils_apiServices_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6815);








var getChapterItemList = function(param) {
    var chapters = param.chapters, itemArray = param.itemArray;
    chapters.forEach(function(chapter) {
        chapter.items.forEach(function(item) {
            itemArray.push(item);
        });
    });
};
var pageDirectJudgment = function(param) {
    var router = param.router, url = param.url, reason = param.reason;
    if (router.query.fromPage) {
        router.push("/".concat(router.query.fromPage, "#").concat(reason));
    } else {
        router.push("".concat(url, "#").concat(reason));
    }
};
var courseDirectHelper = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var courseId, _param_previewType, previewType, router, onError, _ref, url, error, error1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    courseId = param.courseId, _param_previewType = param.previewType, previewType = _param_previewType === void 0 ? "course" : _param_previewType, router = param.router, onError = param.onError;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    if (!courseId) {
                        throw Error("empty course id");
                    }
                    return [
                        4,
                        (0,_router_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCourseContentUrl */ .h5)({
                            courseId: courseId,
                            getLearningSyllabus: function() {
                                return (0,_utils_apiServices_explore__WEBPACK_IMPORTED_MODULE_2__/* .getPublishedCourseInfo */ .X7)(courseId, previewType);
                            },
                            getUserUnfinishedField: _utils_apiServices_user__WEBPACK_IMPORTED_MODULE_3__/* .getUserUnfinishedField */ .Jx,
                            getEnrollStatus: _utils_apiServices_campaign__WEBPACK_IMPORTED_MODULE_1__/* .getEnrollStatus */ .lu
                        })
                    ];
                case 2:
                    _ref = _state.sent(), url = _ref.url, error = _ref.error;
                    if (error) {
                        if (typeof onError === "function") onError();
                        pageDirectJudgment({
                            router: router,
                            url: "".concat(url),
                            reason: error
                        });
                        throw error;
                    } else {
                        if (router) {
                            router.push("".concat(url));
                            return [
                                2,
                                url
                            ];
                        }
                        return [
                            2,
                            url
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error1 = _state.sent();
                    console.error("courseDirect", error1);
                    return [
                        2,
                        "/"
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function courseDirectHelper(_) {
        return _ref.apply(this, arguments);
    };
}();
var checkLearningItemExisted = function(param) {
    var _param_courseInfo = param.courseInfo, courseInfo = _param_courseInfo === void 0 ? null : _param_courseInfo, _param_learningType = param.learningType, learningType = _param_learningType === void 0 ? "" : _param_learningType, _param_learningItemId = param.learningItemId, learningItemId = _param_learningItemId === void 0 ? "" : _param_learningItemId;
    switch(learningType){
        case "attachment":
            var _courseInfo_courseContent;
            return ((_courseInfo_courseContent = courseInfo.courseContent) === null || _courseInfo_courseContent === void 0 ? void 0 : _courseInfo_courseContent.attachmentChapter) !== null;
        case "video":
        case "doc":
        case "document":
        case "h5":
        case "web_link":
        case "asmt":
        case "assessment":
        case "survey":
            {
                var _ref = (courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.courseContent) || {}, _ref_chapters = _ref.chapters, chapters = _ref_chapters === void 0 ? [] : _ref_chapters, _ref_previewVideo = _ref.previewVideo, previewVideo = _ref_previewVideo === void 0 ? {} : _ref_previewVideo;
                var itemArray = [];
                if (previewVideo === null || previewVideo === void 0 ? void 0 : previewVideo.id) {
                    itemArray.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, previewVideo), {
                        type: "video"
                    }));
                }
                getChapterItemList({
                    chapters: chapters,
                    itemArray: itemArray
                });
                var isTarget = function(item) {
                    return item.id === learningItemId && item.type === learningType;
                };
                return typeof itemArray.find(isTarget) !== "undefined";
            }
        default:
            return false;
    }
};
var directToContentNotFound = function(param) {
    var router = param.router, courseId = param.courseId, courseInfo = param.courseInfo, learningItemId = param.learningItemId;
    var _ref = (courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.courseContent) || {}, _ref_chapters = _ref.chapters, chapters = _ref_chapters === void 0 ? [] : _ref_chapters, _ref_previewVideo = _ref.previewVideo, previewVideo = _ref_previewVideo === void 0 ? {} : _ref_previewVideo;
    var itemArray = [];
    if (previewVideo === null || previewVideo === void 0 ? void 0 : previewVideo.id) {
        itemArray.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, previewVideo), {
            type: "video"
        }));
    }
    getChapterItemList({
        chapters: chapters,
        itemArray: itemArray
    });
    var firstContent = itemArray[0];
    if (firstContent) {
        var type = firstContent.type, id = firstContent.id;
        if (learningItemId === id) {
            // already first content id
            pageDirectJudgment({
                router: router,
                url: "/course/preview/".concat(courseId),
                reason: "contentNotFound"
            });
        } else {
            pageDirectJudgment({
                router: router,
                url: "/course/".concat(courseId, "/").concat(type, "/").concat(id),
                reason: "contentNotFound"
            });
        }
    } else {
        pageDirectJudgment({
            router: router,
            url: "/course/preview/".concat(courseId),
            reason: "contentNotFound"
        });
    }
};
var directToCourseNotFound = function(param) {
    var router = param.router;
    pageDirectJudgment({
        router: router,
        url: "/explore",
        reason: "courseNotFound"
    });
};
var directToSyllabusError = function(param) {
    var router = param.router, courseId = param.courseId;
    pageDirectJudgment({
        router: router,
        url: "/course/preview/".concat(courseId),
        reason: "syllabusError"
    });
};
var directToHasNotBeenEnrolledError = function(param) {
    var router = param.router, courseId = param.courseId;
    pageDirectJudgment({
        router: router,
        url: "/course/preview/".concat(courseId),
        reason: "courseHasNotBeenEnrolled"
    });
};
var directToNoLogin = function(param) {
    var router = param.router, courseId = param.courseId, learningType = param.learningType, learningItemId = param.learningItemId;
    if (learningItemId && learningType) {
        pageDirectJudgment({
            router: router,
            url: "/course/preview/".concat(courseId, "?redirect_uri=/course/").concat(courseId, "/").concat(learningType, "/").concat(learningItemId),
            reason: "401"
        });
    } else {
        pageDirectJudgment({
            router: router,
            url: "/course/preview/".concat(courseId),
            reason: "401"
        });
    }
};

var translateToSkillLevel = function(number) {
    switch(number){
        case 1:
            return "beginner";
        case 2:
            return "intermediate";
        case 3:
            return "advanced";
        default:
            return "beginner";
    }
};


/***/ }),

/***/ 26834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useFnsLanguage; }
/* harmony export */ });
/* harmony import */ var _components_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69142);
/* harmony import */ var _locale_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41400);


var useFnsLanguage = function() {
    var language = (0,_components_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)().language;
    var dateLocale = (0,_locale_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleFnsIntl */ .Vp)(language);
    return dateLocale;
};


/***/ }),

/***/ 3894:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","footer":"Footer_footer__HW7x0","content":"Footer_content__35O9W","copy_right":"Footer_copy_right__1GB8U","security_wrapper":"Footer_security_wrapper__divs6","security_content_wrapper":"Footer_security_content_wrapper__uizr7","security_content_icon":"Footer_security_content_icon__j__jw","links":"Footer_links__yg2mM","nav_link":"Footer_nav_link__7VYCA","divider":"Footer_divider__qbikf","qrcode":"Footer_qrcode__KT1d0","code":"Footer_code__USn1V","suggestion":"Footer_suggestion__EwmR5","code_img":"Footer_code_img__OLT3X"};

/***/ })

}]);